module.exports = __webpack_public_path__ + "files/3099553fc79c8bfcd25d48be2fab8219.png";